export default "__VITE_ASSET__B0X9ulIk__"